import DataTable from 'datatables.net-dt';
// import 'datatables.net-responsive-dt'
import 'datatables.net-buttons-dt';
import * as select2 from 'select2'
import {each} from "uikit/src/js/util";
export default {
  init() {
    // JavaScript to be fired on the home page


    function removeDuplicates(arr) {
      return arr.filter((item,
                         index) => arr.indexOf(item) === index);
    }


    let table = new DataTable('#speakers-filter', {
      order: [0, 'asc'],
      pageLength: 25,
      scrollToTop: true,
      colReorder: true,
      buttons:['createState', 'savedStates', 'removeAllStates'],
      language: {
        searchPlaceholder: 'Search...',
      },


      initComplete: function () {
        let filterWrapper = $('#speakers-filter_wrapper');
        filterWrapper.prepend('<div id="filter-controls"><button id="filter-reset" class="uk-border-rounded uk-button uk-button-secondary uk-margin-small-right">Reset</button></div>');
        filterWrapper.prepend('<div id="filter-dropdowns"></div>');

        $('div#filter-controls').wrapAll('<div class="dataTables_filters"></div>');
        $('.dataTables_filters').append($('div#speakers-filter_filter')).append($('div#filter-dropdowns')).append($('div#speakers-filter_length'));

        this.api()
          .columns()
          .every(function (index) {
            let column = this;
            if ( index > 0 && index < 8) {
              // Create select element
              let select = document.createElement('select');
              let selectName = $(column.header()).text().trim();

              select.setAttribute('class', 'dt-select2 '+selectName);
              select.add(new Option(selectName, ''));
              $('#filter-dropdowns').append(select);

              $(select).select2();


              $(select).on('select2:select', function (e) {
                $(select).trigger('change');
                // console.log(select.value);
                // let val = $("<textarea></textarea>").html(DataTable.util.escapeRegex(select.value)).text();
                // var val = DataTable.util.escapeRegex(select.value);

                var div = document.createElement("div");
                div.innerHTML = select.value;
                let val = div.innerText;
                column
                  .search(val ? '.*' + val + '.*' : '', true, false)
                  .draw();
              });

              // Apply listener for user change in value
              // select.addEventListener('change', function () {
              //   var val = DataTable.util.escapeRegex(select.value);
              //
              //   alert('change');
              //   column
              //     .search(val ? '^' + val + '$' : '', true, false)
              //     .draw();
              // });

              // if(index === 1 || index === 4 || index === 5|| index === 6) {
                column
                  .data()
                  .unique()
                  .sort()
                  .each(function (d) {
                    let tests = d.split(', ');
                    tests.forEach(element => {
                      let text =  $("<textarea></textarea>").html(element).text();
                      let exists = false;
                      for (let i = 0; i < select.length; ++i){
                        if (select.options[i].value === text){
                          exists = true;
                        }
                      }
                      if(!exists) {
                        select.add(new Option( text ) );
                      }
                    });
                  });

              // } else {
              //
              // column
              //   .data()
              //   .unique()
              //   .sort()
              //   .each(function (d, j) {
              //     select.add(new Option( $("<textarea></textarea>").html(d).text()));
              //   });
              //
              // }

            }
          });
        //
        // $('.dt-select2.Year ').select2({
        //   sorter: data => data.sort((a, b) =>b.text.localeCompare(a.text)),
        //   escapeMarkup: function (text) { return text; },
        // });
        $('.dt-select2').select2({
          escapeMarkup: function (text) { return text; },
          // debug: true,
        });

      },
      drawCallback: function() {
        // $('.dt-select2').select2();
      },
    });


    $('span.filter-button[data-filter]').on('click', function () {
      let col = $(this).data('column'),
        colClass = $(this).data('class'),
        filter = $(this).data('filter');
      table.columns(col).search(filter).draw();
      $('.dt-select2.'+colClass).val(filter).trigger('change').trigger('change');
    });


    $('#filter-reset').on('click', function () {
      table.columns().search('').draw();
      $('.dt-select2').val(null).trigger('change').trigger('change');
    });


    $('#speakers-filter').on('click', '.modal-link', function () {
      let dataID = $(this).data('id');
      let modalSelector = $(this).attr('href');
      if(dataID) {
        jQuery.ajax({
          type: 'GET',
          url: '/wp-json/mygn/v1/image/',
          data: {
            action: 'download_image',
            // add your parameters here
            image_id: dataID,
          },
          success: function (output) {
            if(output && output !== '0') {
              let modalSelector = $(this).attr('href');
              if('error' in output) {
                $(modalSelector).find('.modal-image-404').removeAttr('hidden').removeClass('uk-hidden');
              } else {
                let headshot = output['value'][0]['large']['url'];
                $(modalSelector).find('.modal-image').attr('src', headshot).removeAttr('hidden').removeClass('uk-hidden');
              }
            }
          }.bind(this),
          error: function (request, status, error) {
            alert(request.responseText);
          },
        });
      } else {
        $(modalSelector).find('.modal-image-404').removeAttr('hidden').removeClass('uk-hidden');
      }
    });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateSpeakers.js